import { memo } from 'react';
import type { ComposerProductInput } from '@vellnes/composer-react';

import {
  SimpleModalButton,
  SimpleModalButtonDefaultProps
} from '../../../../helpers/buttons/SimpleModalButton';

import { composerKeys } from '../../../../locales/keys';
import { TeamNanoID, TeamUUID } from '../../../teams/teamsTypes';

import { ComposerModalContent } from '../ComposerModalContent';

type ComposeSelectedProductsModalButtonProps = Pick<
  SimpleModalButtonDefaultProps,
  | 'className'
  | 'dataGa'
  | 'i18nText'
  | 'icon'
  | 'iconClassName'
  | 'tooltipPlacement'
  | 'tooltipI18nText'
  | 'disabled'
> & {
  products: ComposerProductInput[];
  companyNanoId?: TeamNanoID;
  companyUuid?: TeamUUID;
};

function ComposeSelectedProductsModalButton({
  className,
  dataGa,
  i18nText,
  icon,
  iconClassName,
  tooltipPlacement,
  tooltipI18nText,
  disabled,
  products,
  companyNanoId,
  companyUuid
}: ComposeSelectedProductsModalButtonProps) {
  return (
    <SimpleModalButton
      addModalClassName="h-full overflow-hidden"
      buttonsContainerClassName="p-0"
      childrenClassName="w-full flex-1 min-h-0 relative overflow-hidden"
      className={className}
      dataGa={dataGa}
      disabled={disabled}
      i18nText={i18nText}
      i18nTitle={composerKeys.composeModalTitle}
      icon={icon}
      iconClassName={iconClassName}
      modalSize="full"
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      withoutCancelButton
      withoutSubmitButton
    >
      <ComposerModalContent
        products={products}
        companyNanoId={companyNanoId}
        companyUuid={companyUuid}
      />
    </SimpleModalButton>
  );
}

export default memo(ComposeSelectedProductsModalButton);
